export const PROJECT_STORE_NAME = 'BUILDER_PROJECTS';
